/* Component rendered on the SeriesPage to display the 
   cover info for each Series of IndexShots
 * When clicked on it opens that Series's IndexShots page
 * Contains the SeriesEditForm */
import React, { useState } from "react"
import { Button, Col, Row } from "react-bootstrap"
import Card from "react-bootstrap/Card"
import { Link } from "react-router-dom"
import { axiosInstance, axiosReq } from "../../api/axiosDefaults"
import { PostDropdown } from "../../components/PostDropdown"
import styles from "../../styles/Indexes.module.css"
import btnStyles from "../../styles/Button.module.css"
import Content from "./Content"
import SeriesEditForm from "./SeriesEditForm"
import { useCurrentUser } from "../../contexts/CurrentUserContext"
import useHostName from "../../hooks/useHostName"
import toast from "react-hot-toast";
import { CLIENT_PROGRAM_HOSTNAME } from "../../utils/config"

const SeriesTop = (props) => {
  const host = useHostName()
  const currentUser = useCurrentUser()
  const [showEdit, setShowEdit] = useState(false)
  const [showContent, setShowContent] = useState(false)
  const { id, name, content, seri, setHasOrder, setSeries, fetchseries } = props

  const handleEdit = () => {
    setShowEdit(true)
  }

  const handleDelete = async () => {
    try {
      if (host === CLIENT_PROGRAM_HOSTNAME) {
        await axiosReq.delete(`/series/${id}/`)
        toast.success(`Series Deleted`);
        fetchseries();
      } else {
        await axiosInstance.delete(
          `${localStorage.getItem("projectSlug")}/series/${id}/`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
            withCredentials: true,
          }
        )
        toast.success(`Series Deleted Successfully!`);
        fetchseries();
      }
    } catch (err) {}
  }

  return (
    <div>
      <Card className={`mx-1 text-center ${styles.TopSeries}`}>
        <Row>
        <Col xs={{span: 8, offset: 2}} >
        <hr className={`mt-1 mb-0 ${styles.BreakWhite}`}/>
        </Col>
        </Row>
        <Card.Header className={`py-0`}>
          <Row className="d-flex align-items-center px-3">
            <Col className="mx-0 px-0" xs={1}>
              <Button
                className={`float-right py-0  ${btnStyles.White} ${btnStyles.Button}`}
                onClick={() => setShowContent((showContent) => !showContent)}
              >
                I
              </Button>
            </Col>
            <Col xs={10} className="mx-0 text-center">
              <Link
                to={`/${localStorage.getItem("projectSlug")}/indexshots/${id}`}
              >
                <div>
                  <h5 className={` ${styles.Titlelist}`}>
                    {name}
                  </h5>
                </div>
              </Link>
            </Col>
            <Col xs={1} className={`text-center mx-0 px-0 ${styles.Icon}`}>
              {currentUser &&
                currentUser?.groups.length > 0 &&
                (currentUser?.groups[0]?.name === "Admin" ||
                  currentUser?.groups[0]?.name === "Superadmin" ||
                  currentUser?.groups[0]?.name === "Admincreative") && (
                  <PostDropdown
                    handleEdit={handleEdit}
                    handleDelete={handleDelete}
                  />
                )}
            </Col>
          </Row>
          <Row>
            <Col className="px-0">
              {!showContent ? "" : <Content content={content} />}
            </Col>
          </Row>
        </Card.Header>
        <Row>
        <Col xs={{span: 8, offset: 2}} >
        <hr className={`mt-0 mb-1 ${styles.BreakWhite}`}/>
        </Col>
        </Row>
      </Card>
      {!showEdit ? (
        ""
      ) : (
        <SeriesEditForm
          setSeries={setSeries}
          seri={seri}
          name1={name}
          id={id}
          setShowEdit={setShowEdit}
          setHasOrder={setHasOrder}
        />
      )}
    </div>
  )
}

export default SeriesTop
